'use strict';

export default [
  'ApplicationConfigData',
  class ContactController {
    constructor(applicationConfigData) {
      this.config = applicationConfigData.getConfig();
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/pages/contact/contact.ctrl.js